

export class CustomFunctionReturn {
    constructor(
        public readonly ret: boolean, public readonly res: boolean
    ) {

    }


}



// WEBPACK FOOTER //
// ./src/app/slick-grid/models/custom-function-return.ts